import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalEarned: 0,
};

const financeData = createSlice({
    name: "finance",
    initialState,
    reducers: {
        setFinanceData: (state, action) => {
            const financeDetails = action.payload;
            state.totalEarned = (financeDetails?.total_pro_earnings ? financeDetails?.total_pro_earnings : 0) / 100;
        },
    }
});

export const { setFinanceData } = financeData.actions;

export default financeData.reducer;
